import React, { FunctionComponent } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { TableRow, TableCell, Typography } from "@material-ui/core";
import clsx from "clsx";
import ChipMUI from "@material-ui/core/Chip";
import { formatTwilioPhoneNumber } from "utils/PhoneUtils";

interface Props {
  phoneNumber: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    row: {
      "&.MuiTableRow-root": {
        verticalAlign: "baseline",
      },
    },
    cell: {
      paddingLeft: "0px",
      fontSize: "15px",
      [theme.breakpoints.down("sm")]: {
        paddingTop: "8px",
        paddingBottom: "8px",
      },
      [theme.breakpoints.only("md")]: {
        paddingTop: "13px",
        paddingBottom: "13px",
      },
      [theme.breakpoints.only("lg")]: {
        paddingTop: "17px",
        paddingBottom: "17px",
      },
      [theme.breakpoints.only("xl")]: {
        paddingTop: "26px",
        paddingBottom: "26px",
      },
    },
    phoneNumber: {
      [theme.breakpoints.down("sm")]: {
        paddingLeft: "41px",
      },
      [theme.breakpoints.only("md")]: {
        paddingLeft: "65px",
      },
      [theme.breakpoints.only("lg")]: {
        paddingLeft: "87px",
      },
      [theme.breakpoints.only("xl")]: {
        paddingLeft: "132px",
      },
    },
    text: {
      fontSize: "15px",
      lineHeight: "20px",
    },
    chip: {
      borderColor: "transparent",
      backgroundColor: "#5E8677",
      color: "#fff",
      width: "auto",
      paddingLeft: "12px",
      paddingRight: "12px",
      height: "25px",
      fontSize: "14px",
    },
  })
);

export const PhoneNumberRow: FunctionComponent<Props> = (props) => {
  const classes = useStyles();

  return (
    <TableRow className={classes.row}>
      <TableCell className={clsx(classes.cell, classes.phoneNumber)}>
        <Typography noWrap={true} className={classes.text}>
          {formatTwilioPhoneNumber(props.phoneNumber)}
        </Typography>
      </TableCell>
      <TableCell className={clsx(classes.cell, classes.text)}>
        <ChipMUI
          label="Active"
          className={classes.chip}
          clickable={false}
        />
      </TableCell>
    </TableRow>
  );
};

export default PhoneNumberRow;
